import { createFileRoute } from '@tanstack/react-router'
import { AuthRedirect } from '../../src/pages/PICC/AuthRedirect'
import { piccAuthRedirectSearchSchema } from '../../src/schemas/routeSchemas'

export const Route = createFileRoute('/authRedirect')({
  validateSearch: (search) => piccAuthRedirectSearchSchema.parse(search),
  loaderDeps: ({ search }) => ({ callback: search.callback }),
  staticData: {
    englishAllowed: true,
  },
  component: PiccLegacyAuthRedirectComponent,
})

function PiccLegacyAuthRedirectComponent() {
  const { callback } = Route.useSearch()

  return <AuthRedirect callback={callback} />
}
